import React, { FC, ComponentProps, useEffect } from "react";
import useIsMounted from "~/common/useIsMounted";

const ProductDocument: FC<ComponentProps<"div">> = ({
  className,
  children,
  ...rest
}) => {
  const isMounted = useIsMounted();

  useEffect(() => {
    window.dispatchEvent(new Event("resourcesLoaded"));
  }, [isMounted]);

  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
};

export default ProductDocument;
